import popover from './_popover';
import navTabs from './_bootstrap-nav-tabs';
import openEditorClickEvent from './_open-editor-click-event';

export default function () {
    $(function () {
        navTabs();
        popover();

        // Modals
        $('.modal').on('shown.bs.modal', function () {
            // Allows using tabindex="-1" without breaking autofocus, see http://stackoverflow.com/a/23921617/94289
            $('[autofocus]', $(this)).trigger('focus');
        });

        // Bootstrap expand-collapse buttons used in monitors
        // This event is triggered after the collapsed class is added by bootstrap
        $('.button-expand').on('click', function () {
            if ($(this).hasClass('collapsed')) {
                $(this).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            } else {
                $(this).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            }
        });

        // Prevent form submission with enter key, convert to tab instead. This applies to all forms which have
        // data-enter-to-tab="1".
        // see http://stackoverflow.com/a/12130486/94289
        // Note that textarea is removed from selector so new line works
        $('body').on('keydown', 'input, select', function (e) {
            const form = $(this).parents('form:eq(0)');
            if (form.data('enter-to-tab') && $(this).attr('type') !== 'submit' && $(this).data('enter-to-tab') !== 0 && e.key === 'Enter') {
                const focusable = $('input,select,button,textarea', form).filter(':visible').filter(function () {
                    return $(this).attr('tabindex') !== '-1';
                });
                const next = focusable.eq(focusable.index(this) + 1);
                if (next.length) {
                    next.trigger('focus');
                } else {
                    form.trigger('submit');
                }
                return false;
            }
        });

        // Disable form submit event after the first submission. Prevents multiple form submission by double-click.
        // http://stackoverflow.com/a/926863/94289
        $("form").on('submit', function () {
            if ($(this).data('submit-only-once') === 1) {
                $(this).on('submit', function () {
                    return false;
                });
            }
            return true;
        });

        // Prevent subsequent clicks on links, see http://stackoverflow.com/a/1681973/94289
        $('[data-only-one-click="1"]').one("click", function () {
            $(this).on('click', function () {
                return false;
            });
        });

        // Form elements with this attribute trigger a form submit.
        $('[data-submit-on-change="1"]').on('change', function () {
            const $form = $(this).closest("form");
            const $input = $("<input>").attr("type", "hidden").attr("name", "change-element-name").val($(this).attr('name'));
            $form.append($input);
            $form.trigger('submit');
        });

        // focus first survey-element
        $('input, select, textarea', '#survey').first().trigger('focus');

        // Locale selection in footer
        $('#footer-main #locale-select').on('change', function () {
            window.location.href = <string>$(this).val();
        });

        openEditorClickEvent();
    });
}